import React from "react";
import { Bar, Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    LineController
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    LineController
);

export default function WeatherMixedChart({ data }) {
    const chartData = {
        labels: data.map((d) => d.month),

        datasets: [
            // BAR → Rainfall
            {
                type: "bar",
                label: "Rainfall (mm)",
                data: data.map((d) => d.rainfall),
                backgroundColor: "rgba(191, 138, 46, 0.35)",
                yAxisID: "yRain"
            },

            // LINE → Min Temp
            {
                type: "line",
                label: "Min Temp (°C)",
                data: data.map((d) => d.minTemp),
                borderColor: "#4c6b4f",
                backgroundColor: "#4c6b4f",
                tension: 0.4,
                yAxisID: "yTemp"
            },

            // LINE → Max Temp
            {
                type: "line",
                label: "Max Temp (°C)",
                data: data.map((d) => d.maxTemp),
                borderColor: "#bf8a2e",
                backgroundColor: "#bf8a2e",
                tension: 0.4,
                yAxisID: "yTemp"
            }
        ]
    };

    const textColor = "#6d6655";
    const gridColor = "rgba(43, 40, 32, 0.08)";
    const font = { family: "'Inter', sans-serif" };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false
        },
        plugins: {
            legend: {
                position: "top",
                labels: { color: textColor, font }
            }
        },
        scales: {
            x: {
                ticks: { color: textColor, font },
                grid: { color: gridColor }
            },
            // Rainfall axis
            yRain: {
                type: "linear",
                position: "left",
                ticks: { color: textColor, font },
                grid: { color: gridColor },
                title: {
                    display: true,
                    text: "Rainfall (mm)",
                    color: textColor,
                    font
                }
            },

            // Temperature axis
            yTemp: {
                type: "linear",
                position: "right",
                ticks: { color: textColor, font },
                grid: {
                    drawOnChartArea: false
                },
                title: {
                    display: true,
                    text: "Temperature (°C)",
                    color: textColor,
                    font
                }
            }
        }
    };

    return (
        <div style={{ height: "400px" }}>
            <Bar data={chartData} options={options} />
        </div>
    );
}